import type { NotificationsRecord } from '@/types/pocketbase-types.ts';
import { usePB } from '@/composables/database/use-pocket-base.ts';
import { onUnmounted } from 'vue';
import type { RecordSubscription } from 'pocketbase';

const callbacks = new Map<symbol, (notification: RecordSubscription<NotificationsRecord>) => void>();
let stopUnderlyingSubscription: (() => void) | undefined;

export function useNotificationsSubscription(callback: (notification: RecordSubscription<NotificationsRecord>) => void) {
  const pb = usePB();
  const callbackId = Symbol('notification-subscription');
  callbacks.set(callbackId, callback);
  let stopped = false;

  if (!stopUnderlyingSubscription) {
    stopUnderlyingSubscription = pb.subscribe<NotificationsRecord>(
      'notifications',
      (event) => {
        callbacks.forEach((registeredCallback) => registeredCallback(event));
      },
      (db, user) => ({
        filter: db.filter('user_id = {:userId}', { userId: user.id }),
      }),
      'manual',
    );
  }

  const stop = () => {
    if (stopped) return;
    stopped = true;
    callbacks.delete(callbackId);
    if (callbacks.size === 0) {
      stopUnderlyingSubscription?.();
      stopUnderlyingSubscription = undefined;
    }
  };

  onUnmounted(stop);
  return stop;
}
